<template>
	<div class="pictureList" :class="dayNightMode == 'day' ? 'day-mode' : 'night-mode'">
		<div
			class="line-left"
			:style="{
				background: dayNightMode == 'day' ? '#000' : '#ccc',
			}"
		></div>
		<div
			class="line-center"
			:style="{
				background: dayNightMode == 'day' ? '#000' : '#ccc',
			}"
		></div>
		<ul
			class="c-ul"
			:class="this.$store.state.pictureData.length <= 2 ? '' : 'c-ul-copy'"
			v-if="this.$store.state.pictureData"
			ref="scrollableList"
		>
			<li v-for="(item, index) in this.$store.state.pictureData" :key="index" class="c-li">
				<div class="c-div">
					<img :src="item.img" width="100%" :alt="item.title_cn" @click="jumpContent(item.bz)" />
				</div>
				<p :class="dayNightMode == 'day' ? 'day-mode' : 'night-mode'">{{
					en_cn == 'en' ? item.title_en : item.title_cn
				}}</p>
			</li>
			<div class="c-line" v-if="this.$store.state.pictureData.length < 2"></div>
		</ul>
	</div>
</template>
<script>
	export default {
		data() {
			return {
				cont: [
					{
						src: require('../assets/project-pic4.png'),
						title: 'a.RESTAURANT',
					},
					{
						src: require('../assets/project-pic4.png'),
						title: 'b.RESTAURANT',
					},
					{
						src: require('../assets/project-pic4.png'),
						title: 'c.RESTAURANT',
					},
					{
						src: require('../assets/project-pic4.png'),
						title: 'd.RESTAURANT',
					},
					{
						src: require('../assets/project-pic4.png'),
						title: 'e.RESTAURANT',
					},
					{
						src: require('../assets/project-pic4.png'),
						title: 'f.RESTAURANT',
					},
				],
				// dataList:this.$store.state.pictureData,      // 导航列表

				navId: '', //父列表ID
				navIds: '', //子列表ID
				en_cn: '',
				fat_bool: '',

				dayNightMode: this.$store.state.dayNightMode,
			};
		},
		mounted() {
			// setTimeout(() => {
			// 	this.$refs.scrollableList.addEventListener('scroll', this.handleScroll);
			// }, 1000);
		},
		beforeDestroy() {
			// 组件销毁前移除事件监听
			// this.$refs.scrollableList.removeEventListener('scroll', this.handleScroll);
		},
		updated() {},
		computed: {
			myValue() {
				return this.$store.state.en_cn;
			},
			myFat() {
				return this.$store.state.fat_bool;
			},
		},
		created() {
			this.en_cn = sessionStorage.getItem('lang') || 'cn';
			this.fat_bool = this.$store.state.fat_bool;
			let listUpTitle = sessionStorage.getItem('listUpTitle');
			// console.log('listUpTitle', listUpTitle);
			if (listUpTitle) {
				sessionStorage.removeItem('listUpTitle');
				window.history.replaceState({}, '', window.location.href + '-' + listUpTitle);
				this.DataLists(listUpTitle);
			}
		},
		watch: {
			'$store.state.dayNightMode': function() {
				this.dayNightMode = this.$store.state.dayNightMode;
			},
			'$store.state.homeBz': function(val) {
				console.log('$store.state.homeBz', val);
				if (val) {
					window.history.replaceState({}, '', window.location.href + '-' + val);
					this.DataLists(val);
				}
			},
			myValue: function(newVal, oldVal) {
				console.log('newVal', newVal);
				this.en_cn = newVal;
			},
			myFat: function(newVal, oldVal) {
				this.fat_bool = newVal;
				console.log(this.fat_bool, 'fat_bool');
			},
		},
		methods: {
			handleScroll() {
				const element = this.$refs.scrollableList;
				const scrollTop = element.scrollTop;
				const clientHeight = element.clientHeight;
				const scrollHeight = element.scrollHeight;
				if (scrollTop + clientHeight >= scrollHeight) {
					console.log('UI标签已滚动到底部');
					if (this.myFat == 1) {
						this.$store.state.homePage++;
						console.log('请求数据', this.$store.state.homePage);
						let arr = JSON.parse(JSON.stringify(this.$store.state.pictureData));
						this.$store.state.pictureData.push(...arr);
					}
				}
			},
			// 子列表请求
			DataLists(bz) {
				this.$post('api/home/ProjectsList', { id: bz }).then((res) => {
					this.$store.state.pictureData = res.data;
				});
			},

			// 点击父列表
			jumpContent(bz) {
				this.$store.state.projectsContBz = bz;
				this.$router.push({
					name: 'ProjectsCont',
				});
			},
		},
	};
</script>
<style lang="less" scoped>
	* {
		box-sizing: border-box;
	}
	.pictureList {
		padding-top: 0.1823rem;
		position: relative;
		background: #dbdcdc;
		.line-left {
			position: absolute;
			left: 0;
			top: 0;
			width: 1px;
			min-height: 100vh;
		}
		.line-center {
			position: absolute;
			left: calc(50% - 1px);
			top: 0;
			width: 1px;
			min-height: 100vh;
		}
	}
	@font-face {
		font-family: nexalight;
		src: url(../../public/font/NexaLight.otf);
	}
	@font-face {
		font-family: nexaBold;
		src: url(../../public/font/NexaBold.otf);
	}

	.c-line {
		content: ' ';
		width: 1px;
		height: 100vh;
		background: #000;
		position: absolute;
		top: 0;
		right: 40.5%;
		left: 0;
		right: 0;
		// bottom: 0;
		margin: auto;
	}

	.c-ul-copy {
		li:nth-child(odd) {
			position: relative;
		}
	}

	ul::-webkit-scrollbar {
		width: 0px;
		height: 0px;
	}

	.c-div {
		overflow: hidden;
		box-sizing: border-box;
		margin-bottom: 20px;
		background: #bbb;
	}

	ul {
		height: 100vh;
		overflow: scroll;

		position: relative;
		li {
			width: 50%;
			padding: 0 30px 20px 30px;

			display: inline-block;
			box-sizing: border-box;
			img {
				cursor: pointer;
			}
			p {
				font-size: 25px;
				color: #231815;
				line-height: 22px;
				font-family: nexalight;
				cursor: default;
			}
			p:hover {
				font-family: nexaBold;
			}
		}
		li:nth-last-child(1) {
			margin-bottom: 20px;
		}
		@media screen and (max-width: 870px) {
			li {
				width: 100%;
				display: block;
				padding: 0;
			}
			li:nth-child(1) {
				padding: 20px 0;
			}
			li:nth-child(2) {
				padding: 0;
			}
		}
	}
</style>
